export { LocationVariant } from '../components/Location/types.js';

const ADDRESS_CONFIGURATION_SIZES = [
    'MINIMAL',
    'SMALL',
    'MEDIUM',
    'LARGE',
    'COMPLETE', 
];
const OPENING_HOURS_DAYS = [
    'sunday',
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday', 
];
var OpenClosedStatus;
(function(OpenClosedStatus) {
    OpenClosedStatus["Open"] = 'OPEN';
    OpenClosedStatus["Closing"] = 'CLOSING';
    OpenClosedStatus["Closed"] = 'CLOSED';
})(OpenClosedStatus || (OpenClosedStatus = {}));

export { ADDRESS_CONFIGURATION_SIZES, OPENING_HOURS_DAYS, OpenClosedStatus };
//# sourceMappingURL=index.js.map
